import script from "./TablesMyRequest.vue?vue&type=script&setup=true&lang=js"
export * from "./TablesMyRequest.vue?vue&type=script&setup=true&lang=js"

import "./TablesMyRequest.vue?vue&type=style&index=0&id=7c4da251&lang=css"

const __exports__ = script;

export default __exports__